import actions from './actions';

const initialState = {
  isSearching: false,
  isCreating: false,
  isUpdating: false,
  isDeleting: false,
};

export default function memberCampaignReducer(state = initialState, action) {
  switch (action.type) {
    case actions.CREATE_MEMBER_CAMPAIGN:
    case actions.TRIGGER_MEMBER_CAMPAIGN:
      return {
        ...state,
        isCreating: true,
      };
    case actions.CREATE_MEMBER_CAMPAIGN_ENDED:
    case actions.TRIGGER_MEMBER_CAMPAIGN_ENDED:
      return {
        ...state,
        isCreating: false,
      };
    case actions.SEARCH_MEMBER_CAMPAIGNS:
      return {
        ...state,
        isSearching: true,
      };
    case actions.SEARCH_MEMBER_CAMPAIGNS_ENDED:
      return {
        ...state,
        isSearching: false,
      };
    case actions.UPDATE_MEMBER_CAMPAIGN:
      return {
        ...state,
        isUpdating: true,
      };
    case actions.UPDATE_MEMBER_CAMPAIGN_ENDED:
      return {
        ...state,
        isUpdating: false,
      };
    case actions.DELETE_MEMBER_CAMPAIGNS:
      return {
        ...state,
        isDeleting: true,
      };
    case actions.DELETE_MEMBER_CAMPAIGNS_ENDED:
      return {
        ...state,
        isDeleting: false,
      };
    case actions.GET_MEMBER_CAMPAIGN_TRIGGER_RECORD_STATISTICS:
      return {
        ...state,
        isSearching: true,
      };
    case actions.GET_MEMBER_CAMPAIGN_TRIGGER_RECORD_STATISTICS_ENDED:
      return {
        ...state,
        isSearching: false,
      };
    default:
      return state;
  }
}
